export const offsetOrigins = [
  "topLeft",
  "topCenter",
  "topRight",
  "centerLeft",
  "center",
  "centerRight",
  "bottomLeft",
  "bottomCenter",
  "bottomRight",
] as const;

export type OffsetOrigin = (typeof offsetOrigins)[number];

export type InsetProperty = "top" | "right" | "bottom" | "left";

export type ComputedInset = Record<InsetProperty, number>;

export type SliderDirection = "from-left" | "from-right" | "from-top" | "from-bottom";

export type NumericInsets = Partial<Record<InsetProperty, number>>;
